import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import am from './am.json';
import en from './en.json';

/** PL-12: every visible string comes from a key that exists in both am.json and en.json (checked in CI). */
void i18n.use(initReactI18next).init({
  resources: { am: { translation: am }, en: { translation: en } },
  lng: 'am',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
